import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'rsuite';

const DeleteEntryModal = ({ open, onClose, cardName, collectionName, collectionType, onConfirm, loading }) => (
  <Modal open={open} onClose={onClose} size="xs">
    <Modal.Header>
      <Modal.Title>Delete Entry</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to remove{' '}
      <strong>{cardName}</strong> from <strong>{collectionName}</strong>?
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="subtle">
        Cancel
      </Button>
      <Button onClick={onConfirm} appearance="primary" color="red" loading={loading}>
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteEntryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  cardName: PropTypes.string,
  collectionName: PropTypes.string,
  collectionType: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DeleteEntryModal.defaultProps = {
  cardName: '',
  collectionName: '',
  collectionType: null,
  loading: false,
};

export default DeleteEntryModal;
